import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Row, Col, Form, FormControl, Offcanvas, Button } from "react-bootstrap";
import { FaSearch, FaShoppingCart, FaAngleDown, FaTrashAlt } from "react-icons/fa";
import "../nav.scss";
import logo from "../images/qh-logo.jpg";
import consumerImg from "../images/consumer-wrapper.webp";
import professionalImg from "../images/professional.webp";
import smartLightingImg from "../images/smartlighting.jpeg";
import pcbImg from "../images/mainpc.jpg";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import ourProductImg from "../images/our_product.png";
import axios from "axios";
import config from "../config.js"

function NewNav() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [hoveredTab, setHoveredTab] = useState(null);
  const [hoveredSubCategory, setHoveredSubCategory] = useState(null);
  const [showSlogan, setShowSlogan] = useState(false);
  const [consumerProducts, setConsumerProducts] = useState([]);
  const [professionalProducts, setProfessionalProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [orderCount, setOrderCount] = useState(0);
  const [orderdata, setOrderdata] = useState([]);
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShowSlogan(true);
    }, 500);
  }, []);

  useEffect(() => {
    // Fetch consumer products
    axios.get(`${config.API_BASE_URL}/api/getconsumer`)
      .then((response) => {
        setConsumerProducts(Array.isArray(response.data) ? response.data : []);
      })
      .catch(() => setConsumerProducts([]));

    // Fetch professional products
    axios.get(`${config.API_BASE_URL}/api/getprofessional`)
      .then((response) => {
        setProfessionalProducts(Array.isArray(response.data) ? response.data : []);
      })
      .catch(() => setProfessionalProducts([]));

    // Fetch order count
    axios.get(`${config.API_BASE_URL}/api/getorder`)
      .then((response) => setOrderCount(response.data.order_count))
      .catch(console.error);

    // Fetch order data
    axios.get(`${config.API_BASE_URL}/api/getorderbyid`)
      .then((response) => setOrderdata(response.data))
      .catch(console.error);
  }, []); // Runs only once on component mount

  // Delete Order Function
  const deleteOrder = (id) => {
    axios.get(`${config.API_BASE_URL}/api/order/${id}`)
      .then(() => {
        setOrderdata(orderdata.filter((order) => order.id !== id));
        alert("Order deleted successfully");
        window.location.reload();
      })
      .catch(() => alert("Error deleting order"));
  };



  const categories = {
    Consumer: {
      items: consumerProducts.length > 0 ? consumerProducts : [
        { id: 1, category_name: "LED Bulb", image_url: "/default-led-bulb.jpg" },
        { id: 2, category_name: "LED COB", image_url: "/default-led-cob.jpg" },
        { id: 3, category_name: "LED Downlights", image_url: "/default-downlight.jpg" },
        { id: 4, category_name: "LED Tube Light", image_url: "/default-tube-light.jpg" },
        { id: 5, category_name: "LED Batten Light", image_url: "/default-batten-light.jpg" },
        { id: 6, category_name: "LED Surface Panel", image_url: "/default-surface-panel.jpg" },
        { id: 7, category_name: "LED Slim Panel Lights", image_url: "/default-slim-panel.jpg" },
        { id: 8, category_name: "LED Adjustable Panel Lights", image_url: "/default-adjustable-panel.jpg" },
      ],
    },
    Professional: {
      items: professionalProducts.length > 0 ? professionalProducts : [
        { id: 9, category_name: "LED Spot Light", image_url: "/default-led-bulb.jpg" },
        { id: 10, category_name: "LED Tube Lights", image_url: "/default-led-bulb.jpg" },
        { id: 11, category_name: "LED Panel Lights", image_url: "/default-panel-light.jpg" },
        { id: 12, category_name: "LED Flood Lights", image_url: "/default-flood-light.jpg" },
        { id: 13, category_name: "LED Street Lights", image_url: "/default-street-light.jpg" },
        { id: 14, category_name: "LED Highbay Lights", image_url: "/default-highbay-light.jpg" },
        { id: 15, category_name: "LED T Series Bulbs", image_url: "/default-t-bulb.jpg" },
        { id: 16, category_name: "LED Stadium Lights", image_url: "/default-stadium-light.jpg" },
        { id: 17, category_name: "LED Solar Street Lights", image_url: "/default-solar-street.jpg" },
      ],
    },
  PCB: {
  items: [
    { 
      id: 1, 
      category_name: "Our Product", 
         image_url: ourProductImg,
      link: "/Ourproduct" 
    },
  ],
  images: {
    "Aluminum PCB": pcbImg,
  },
}
    // "Smart Lighting": {
    //   items: [],
    //   images: {
    //     "Smart Bulb": smartLightingImg,
    //   },
    // },
   
  };
  const categoryLinks = {
    Consumer: "/consumer-product",
    Professional: "/professional-product",
    PCB: "/Ourproduct",
    // "Smart Lighting": "/smartlighting",
 
  };
  const categoryImages = {
    Consumer: consumerImg,
    Professional: professionalImg,
    PCB: pcbImg,
    // "Smart Lighting": smartLightingImg,
    
  };
  const orderedCategories = ["Consumer", "Professional", "PCB"];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".custom-dropdown") && !event.target.closest(".dropdown-icon-wrapper")) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchTerm(query);

    if (query) {
      const filteredConsumer = consumerProducts.filter(product =>
        product.category_name?.toLowerCase().includes(query)
      );
      const filteredProfessional = professionalProducts.filter(product =>
        product.category_name?.toLowerCase().includes(query)
      );
      setSearchResults([...filteredConsumer, ...filteredProfessional]);
    } else {
      setSearchResults([]);
    }
  };
  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  return (
    <>
      <div className={`slogan-container ${showSlogan ? "show" : ""}`}>
        <p className="animated-slogan">"Bringing Innovation to Light"</p>
      </div>
      <div className="new-nav-wrapper">
        <Navbar expand="lg" className="custom-navbar">
          <Container>
            <Navbar.Brand href="#home" className="logo">
              <img src={logo} alt="QH Lighting" className="logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto gap-2">
                <Nav.Link href="/">Home</Nav.Link>
                <Nav.Link href="/news">What’s New</Nav.Link>
                  <Nav.Link href="/new">News</Nav.Link>
                <div
                  className="nav-item"
                  onMouseEnter={() => setShowDropdown(true)}
                  onMouseLeave={() => setShowDropdown(false)}
                >
                <Nav.Link 
                as={Link} 
                to="/product" 
                className="inspiration-link" 
                onClick={(e) => {
                  if (window.location.pathname === "/product") {
                    e.preventDefault(); // ✅ Default navigation roko
                    window.location.reload(); // ✅ Page refresh karwao
                  }
                }}
              >
                Products
              </Nav.Link>
              
                  <AnimatePresence>
                    {showDropdown && (
                      <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="custom-dropdown full-width-dropdown show"
                      >
                    <Row className="dropdown-row full-width">
          {orderedCategories.map((category, index) => (
            <Col
              key={index}
              md={2}
              className="dropdown-col"
              onMouseEnter={() => {
                setHoveredTab(category);
                setHoveredSubCategory(null); // Reset sub-category when hovering over category
              }}
              onMouseLeave={() => setHoveredTab(null)} // Remove image when not hovering
            >
              <h6>
                <Link to={categoryLinks[category] } className="category-link">
                  {category}
                </Link>
              </h6>
              <ul>
                                {categories[category]?.items?.map((item, i) => (
                                  <li
                                    key={i}
                                    onMouseEnter={() => setHoveredSubCategory(item)}
                                    onMouseLeave={() => setHoveredSubCategory(null)}
                                  >
                                    {item.link ? (
                                      <Link
                                        to={item.link}
                                        className="dropdown-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          window.location.href = item.link;
                                        }}
                                      >
                                        {item.category_name}
                                      </Link>
                                    ) : (
                                      <Link
                                        to={`/ProductList/${item.id}`}
                                        className="dropdown-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          window.location.href = `/ProductList/${item.id}`;
                                        }}
                                      >
                                        {item.category_name}
                                      </Link>
                                    )}
                                  </li>
                                ))}
                              </ul>
            </Col>
          ))}
 
              {/* Image Column */}
              <Col md={6} className="image-column">
                <AnimatePresence mode="wait">
                  {(hoveredTab || hoveredSubCategory) && (
                    <motion.img
                      key={hoveredSubCategory ? hoveredSubCategory.image_url : hoveredTab}
                      src={
                        hoveredSubCategory?.image_url ||  // Show sub-category image if hovering
                        categoryImages[hoveredTab] || 
                        categories[hoveredTab]?.items?.[0]?.image_url || 
                        "/fallback-image.jpg"
                      }
                      alt="Category Preview"
                      style={{ width: "100%" }}
                      initial={{ opacity: 0, scale: 0.8, x: -50 }}
                      animate={{ opacity: 1, scale: 1, x: 0 }}
                      exit={{ opacity: 0, scale: 0.8, x: 50 }}
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                    />
                  )}
                </AnimatePresence>
              </Col>
            </Row>

                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
                <Nav.Link href="/about" className="sales">About</Nav.Link>
                <Nav.Link href="/support">Support</Nav.Link>
                <Nav.Link href="/contact">Contact</Nav.Link>
                <Form className="d-flex search-bar mt-1">
                  <FormControl type="search" placeholder="Search..." className="me-2" value={searchTerm} onChange={handleSearch} />
                </Form>

                <Nav.Link className="cart-icon" onClick={() => setShow(true)}>
                  <FaShoppingCart />
                  <span className="cart-badge">{orderCount}</span>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
      {searchTerm && searchResults.length > 0 && (
        <div className="search-results">
          {searchResults.map((product) => (
            <div key={product.id} className="search-item" >
              <a href={`/ProductList/${product.id}`}>{product.category_name}</a>
            </div>
          ))}
        </div>
      )}

      <Offcanvas show={show} onHide={() => setShow(false)} placement="end" className="offcanvas-modal">
        <div className="shopping-cart-page" style={{ overflowY: "scroll" }}>
          <div className="cart-container">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title >Shopping Cart</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Container>
                <Row>
                  {orderdata.map((order, index) => (
                    <Col md={12} className="cart-item" key={index}>
                      <img src={order.img} alt="Product" />
                      <div className="cart-details">
                        <p>Order Id: {order.orderid}</p>
                        <h2 className="heading-content">{order.product_model}</h2>
                        <p>Status: {order.status}</p>
                      </div>
                      <div className="remove-section">
                        <div className="price">Rs. {order.price}</div>
                        <FaTrashAlt className="trash-icon" onClick={() => deleteOrder(order.orderid)} />
                      </div>
                    </Col>
                  ))}
                </Row>
              </Container>
              <Button className="w-100 mt-3" style={{ background: "#143A84", border: "none" }}>
                <a href="/checkoutpage" className="shopping-btn" style={{ color: "white", textDecoration: "none", background: "#143A84", border: "none" }}>
                  Checkout
                </a>
              </Button>
            </Offcanvas.Body>
          </div>
        </div>

      </Offcanvas>
    </>

  );
}

export default NewNav;
